import { Action } from '@ngrx/store';
import { ObservableAction } from './observable-action';
import { CloudinaryImageUpdateRequest } from '@core/data/api/cloudinary/cloudinary-image-update-request';
import { CLOUDINARY_PICTURE_UPDATE } from '@core/state/action-types';

@ObservableAction()
export class UpdateCloudinaryAvatarAction implements Action {
    readonly type = CLOUDINARY_PICTURE_UPDATE;

    constructor(public payload: {
        targetId: string, // could be companyId, locationId or userId
        request: CloudinaryImageUpdateRequest
    }) {}
}
